import React from "react";
import Sol from "./Sol";

export default function Filter(props) {

    const { filter: {
        AttributeTypeId,
        AttributeValueFacets,
        Name,
    },
        appliedFilters,
        handleFilterChange } = props

    return (
        <div className="filter-section">
            <div className="select-options">
                <Sol defaultValue={appliedFilters.map(filter => JSON.stringify(filter))} id={`filter-${AttributeTypeId}`}
                    name={`filter[${AttributeTypeId}][]`} placeholder={Name} onChange={handleFilterChange}>
                    {
                        AttributeValueFacets.map((filterFacet, i) => (
                            <option key={`filteroption-${i}`} value={JSON.stringify({
                                id: filterFacet.AttributeValueId,
                                text: filterFacet.ValueDisplay
                            })}>
                                {filterFacet.ValueDisplay}
                            </option>
                        ))
                    }
                </Sol>
            </div>
        </div>
    );
}